var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 40,
    viewBox: "0 0 19 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.502747,
    y: 0.475586,
    width: 17.5882,
    height: 39,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_47_42885",
    transform: "scale(0.0434783 0.0196078)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_47_42885",
    width: 23,
    height: 51,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAzCAYAAAB8F5OAAAAABHNCSVQICAgIfAhkiAAAAxpJREFUWEe1mEtuGkEQhjOwg0XwCWJOEHIC4x0vyfYJTG6ATxB8guATBJ/AWOK1y3CCkBOEnCBEAlY88tdoetTT09UPDxlpBGK6vqn+u6q6muCd5Wq1WjUM+YK7FgRBBZ/L0+k0mk6nTzbbwDQA4C6A35gx4WQyuTbZs3DyGOAfJmPM4BEz6HNjTPAR4De2qW+324swDNe6cSb4CvAPNjjGXI/H49AXvobh+/8FDwG/ssEPh0N1Pp+vfD03RUrEwoIusKB17wUlA0QMu6gA/z0ejzXOa7I3xnn8gj7koSRKLvIY4K4J7AQXxE6nE01/v9+vbFBhw3reaDQuC4XCPe6FGmrxsxvMaI0sffbSXE17yEAxH0UEvlfwneqNuEIk0p0ukTKeN5vNW3j7YgtB5bm2zmTg8NopM9WX6zI1BadFw7S/e3othj9D/65sm4K32+0hHt6/Eb6G9lVZ+wRer9cr5XL5F8C0Ibzpwqw/I2PJwehK4JaNwfVlqYWV4U6FyvYWuZBFcEqKYrFIkuS+IM0TpOklskCSVP2gouRSywmAsb/lTYUSDvCqDFdjm1LaNWoeMParPGUUtbvZbDYKdLFNCeEa7zQWsKGyJUYxH6ixTdPEtC7x+8llAWJHqNakvKeNO4Deqb1StAs+8M1ms0SO/JGdoZgneEpvEUo+cCrJ6q4F+CeC05RGcWb2RIb5winDS6USbYtXIhzZzcIXrluf3HBTS+cF1yWXN5yr67Trq43SOeGPmjbjFUFw66y5znOSBICBrofhui6t5mohiwvUAp9UljMN0lng6Ar6as2Rq6AqjY/nr4APdAUNRUrL4eCZBpSiAvDwHPDMlkfw3W43UAsUScH16JznWjgdrnRlgTu6cPDMkUUAcsNNADxbQomPum3NKVpMcOQAK5kVzrUZItxywbmiJeC6flLuVWTvMwtqg3OlQVcCXJv/n/A8Ok3kgtuMdQ0rdx7NeA5Nqc9L9SAwTmo2I1syM6Pm8UltKfeKoj0ThppYf4BsA2soxrrSfy09OrnhHlLfJxvGbUQfv9E6DOWGXx73Dx6WTW5FtLeNAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.ac3a3128.svg";
export { ForwardRef as ReactComponent };